import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';

@Component({
  selector: 'piqet-angular-new-area-based-conversion',
  templateUrl: './new-area-based-conversion.component.html',
  styleUrls: ['./new-area-based-conversion.component.scss'],
})
export class NewAreaBasedConversionComponent {
  headerData: any;
  headerName = '';
  modalLabel: any;
  areaBasedConversionData: any;
  areaBasedConversionForm!: FormGroup;
  areaBasedConversionAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  organizationlist: any;
  conversionList: any;
  regionList: any;
  selectOrganization: any;
  regionData: any;
  selectRegion: any;
  setIndicatorData: any;
  indicatorList: any;
  isHideDropDown!: boolean;
  isDisabledDropDown!: boolean;
  @Output() saveNewAreaBasedConversionEvent = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private administratorService: AdministratorService
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.areaBasedConversionData =
      this.modal?.modalService?.config?.initialState?.['newConversionData'];
    this.isDisabledDropDown = this.modalLabel == 'Review conversion detail' ? true : false;

    const placeHolderOrganization = {
      name: 'All organization',
    };

    const newOrganizationlist = [placeHolderOrganization].concat(
      this.areaBasedConversionData.organizationList
    );

    this.indicatorList = this.areaBasedConversionData.indicatiorList;
    this.organizationlist = newOrganizationlist;
    this.conversionList = this.areaBasedConversionData.convertingProcessItems;
    this.regionList = this.areaBasedConversionData.regionItems;
    this.organizatioListFunction();
    this.getRegionData();
  }

  ngOnInit(): void {
    const form = [];
    for (let i = 0; i < this.indicatorList.length; i++) {
      form[this.indicatorList[i].name] = new FormControl(
        this.areaBasedConversionData.indicatiorList[i].defaultValue || 0,
        Validators.required
      );
    }
    this.areaBasedConversionForm = new FormGroup(form);
    this.areaBasedConversionAddEditForm = this.formBuilder.group({
      conversion: [this.areaBasedConversionData.convertingProcessId || null, Validators.required],
      region: [null, Validators.required],
      organizationName: [
        this.areaBasedConversionData.organizationId || this.organizationlist[0] || null,
      ],
    });
    this.setFormData();
  }

  onClose() {
    this.modal.close();
  }

  onChange(value: any) {
    this.areaBasedConversionAddEditForm.controls['region'].setValue(null);
    if (!!value?.id) {
      this.administratorService
        .GetRegionsForAreaBasedConversion(value.id)
        .subscribe((data: any) => {
          this.regionData = data.data;
        });
    } else {
      this.regionData = [];
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForRegion(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.areaBasedConversionData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  async getRegionData() {
    await this.regionList.map((item: any) => {
      if (item.id == this.areaBasedConversionData.regionId) {
        return (this.selectRegion = item);
      }
    });
  }

  setFormData() {
    this.areaBasedConversionAddEditForm.patchValue({
      region: this.selectRegion,
      organizationName: this.selectOrganization,
    });
  }

  onSave() {
    this.submitted = true;
    if (
      this.areaBasedConversionAddEditForm.controls['region'].value?.name == '--Select Region-- ' ||
      (this.activatedRoute == 'area-based-conversion' &&
        !this.areaBasedConversionAddEditForm.controls['region'].value?.name)
    ) {
      return;
    }
    if (
      this.areaBasedConversionAddEditForm.status == 'VALID' &&
      this.areaBasedConversionForm.status == 'VALID'
    ) {
      const entires = Object.entries(this.areaBasedConversionForm.value);
      const resultArray: any = [];
      let i = {};
      const entiresArray = this.areaBasedConversionData.indicatiorList.map(
        (obj: any, index: any) => ({
          ...obj,
          ...entires[index],
        })
      );
      entiresArray.forEach((event: any, index: any) => {
        i = {
          indicatorId: event.indicatorId,
          name: event.name,
          unit: event.unit,
          defaultValue: event[1],
          equivalencyUnits: event.equivalencyUnits,
          multiplier: event.multiplier,
        };
        resultArray.push(i);
      });
      const conversionPayload = {
        convertingProcessId: this.areaBasedConversionAddEditForm.controls['conversion'].value,
        regionId:
          this.areaBasedConversionAddEditForm.controls['region'].value?.id ||
          this.areaBasedConversionData.regionId,
        organizationId:
          this.areaBasedConversionAddEditForm.controls['organizationName'].value?.name ==
            'All organization' ||
          this.areaBasedConversionAddEditForm.controls['organizationName'].value?.name == undefined
            ? null
            : this.areaBasedConversionAddEditForm.controls['organizationName'].value?.id,
        indicatiorList: resultArray,
      };
      this.saveNewAreaBasedConversionEvent.emit(conversionPayload);
      this.onClose();
    }
  }
}
